import { ProductType } from "../mislaka_xml_models";

export interface GroupByContactId {
    contact_id: number;
    reported_period: string;
    count: number;
  }
  
  export interface GroupByReportedPeriod {
    reported_period: string;
    handler_code: string;
    distinct_count_contact_id: number;  // מספר המשתמשים הייחודיים
    count_policy_number: number;  // מספר הפוליסות
    sum_funds_sum: number;  // סכום כולל של funds_sum
    sum_deposit_amount: number;  // סכום כולל של funds_sum
    sum_withdrawal_amount: number;  // סכום כולל של funds_sum
}
  
  export interface GroupByContactProductHandler {
    contact_id: number;
    product_type: string;
    handler_code: string;
    count: number;
  }

  export interface AgentCodeGroup {
    handler_code: string;
    count_agent_code: number;
    agent_code: string;
    sum_funds_sum: number;
    sum_deposit_amount: number;
    sum_withdrawal_amount: number;
  }

  export interface GroupByReportedHandlerProduct {
    reported_period: string;
    handler_code: string;
    product_type: number;
    sum_funds_sum: number;
    count_policy_number: number;
}
export interface MonthlyReturn {
  reported_period: string; // date as ISO string
  total_funds_sum: number;
  total_deposit: number;
  total_withdrawal: number;
  return_amount: number;
}

export interface DepositsWithdrawalsTransfers {
  reported_period: string;
  product_type: number;
  sum_deposit_amount: number;
  sum_withdrawal_amount: number;
  sum_transfer_out: number;
  sum_transfer_in: number;
}
export interface ReportedPeriod {
  reported_period: string;
  policy_count: number;
  user_id: number;
  type: "REGULAR" | "PRE_ADVICE"; // ⬅️ הוספת שדה
}
export enum ChangeType {
  NEW_POLICY = "NEW_POLICY", // פוליסה חדשה
  DEPOSIT_FEE_CHANGED = "DEPOSIT_FEE_CHANGED", // שינוי בעמלת הפקדה
  SAVING_FEE_CHANGED = "SAVING_FEE_CHANGED", // שינוי בעמלת חיסכון
  DEPOSIT_AMOUNT_DECREASED = "DEPOSIT_AMOUNT_DECREASED", // ירידה בסכום ההפקדה
  WITHDRAWAL_AMOUNT_INCREASED = "WITHDRAWAL_AMOUNT_INCREASED", // עלייה בסכום המשיכה
  POLICY_BALANCE_ZEROED = "POLICY_BALANCE_ZEROED", // עלייה בסכום המשיכה
  TRANSFER_OUT_CHANGED = "TRANSFER_OUT_CHANGED", // שינוי בכספים יוצאים
  TRANSFER_IN_CHANGED = "TRANSFER_IN_CHANGED", // שינוי בכספים נכנסים
  AGENT_APPOINTMENT_DATE_CHANGED = 'AGENT_APPOINTMENT_DATE_CHANGED',
  MISSING_POLICY = 'MISSING_POLICY',
  FUND_IDS_CHANGED = "FUND_IDS_CHANGED"
}
export interface MimshakComparisonDTO {
  contact_id: number; // מזהה משתמש
  handler_code: string; // קוד המטפל
  product_type: ProductType; // סוג המוצר
  
  // תאריכי הדוח
  current_report_date: string; // תאריך הדוח הנוכחי (בפורמט ISO string)
  previous_report_date?: string; // תאריך הדוח הקודם (בפורמט ISO string)
  
  // סך הכל קרנות
  new_funds_sum: number;
  previous_funds_sum?: number;
  
  // מספר פוליסה (חובה)
  policy_number: string;
  
  // דמי הפקדה (חדשים + קודמים)
  new_deposit_fee?: number;
  previous_deposit_fee?: number;
  
  // דמי חיסכון (חדשים + קודמים)
  new_saving_fee?: number;
  previous_saving_fee?: number;
  
  // סכום הפקדה (חדשים + קודמים)
  new_deposit_amount?: number;
  previous_deposit_amount?: number;
  
  // סכום משיכה (חדשים + קודמים)
  new_withdrawal_amount?: number;
  previous_withdrawal_amount?: number;
  
  new_transfer_out?: number; // אם קיים ערך נוכחי גדול מ-0
  new_transfer_in?: number; // אם קיים ערך נוכחי גדול מ-0

  new_agent_appointment_date?: string;
  // סוגי השינויים (מערך של Enum)
  change_type: ChangeType[];

  new_fund_ids?: number[]; // optional array of fund IDs
  previous_fund_ids?: number[]; // optional array of previous fund IDs
}